import styled from 'styled-components';
import { Row as RawRow } from 'components/shared/Layout';
import FormattedCurrency from 'components/ui/FormattedCurrency';

export const BoldFormattedCurrency = styled(FormattedCurrency)`
  font-weight: bold;
`;

export const BorderedRow = styled(RawRow)`
  border-top: 1px solid grey;
  border-bottom: 1px solid grey;
  font-weight: 600;
`;
